import { OverviewPendingModelsSection } from "../overview-pending-models";
import { OverviewRecentFormsSection } from "../overview-recent-forms";
import { OverviewRecentIssuesSection } from "../overview-recent-issues";
import styles from "./OverviewActivityGrid.module.scss";

export const OverviewActivityGrid = () => {
  return (
    <div className={styles["comp"]}>
      <OverviewRecentFormsSection />
      <OverviewRecentIssuesSection />
      <OverviewPendingModelsSection />
    </div>
  );
};
